/** When `wantShow` (profile pref), align with Tailwind `md` (768px): sidebar on desktop only. */
export function getInitialShowTranscript(wantShow: boolean): boolean {
  if (!wantShow) return false;
  if (typeof window === 'undefined') return false;
  try {
    const mq = window.matchMedia?.('(min-width: 768px)');
    return mq?.matches ?? false;
  } catch {
    return false;
  }
}
